import React from 'react';
import { MessageSquareIcon, SearchIcon, KeyIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Reveal } from './Reveal';
const STEPS = [{
  number: '01',
  icon: MessageSquareIcon,
  title: 'how.1.title'
}, {
  number: '02',
  icon: SearchIcon,
  title: 'how.2.title'
}, {
  number: '03',
  icon: KeyIcon,
  title: 'how.3.title'
}];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white" data-id="element-105" data-mp="lktg67vh4uhb">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-20" data-id="element-106" data-mp="qj3g0vs58j99">
        <Reveal data-id="element-107" data-mp="ql7h75ynr45u">
          <h2 className="font-display text-2xl font-extrabold uppercase tracking-[0.16em] text-ink sm:text-3xl" data-id="element-108" data-mp="cs81p3yvl9ya">
            {t('how.title')}
          </h2>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-109" data-mp="gs0anhs6li46" />
        </Reveal>
        <ol className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-110" data-mp="14hkyadza53js">
          {STEPS.map((step, index) => {
          const Icon = step.icon;
          return <li key={step.number} className="border-t border-camel/40 pt-5" data-id="element-111" data-mp="2rkwdyzc3udnf" data-mpi={index}>
                <Reveal delay={index * 0.08} data-id="element-112" data-mp="2mmuuidarocbf">
                  <div className="flex items-center gap-3" data-id="element-113" data-mp="2mo5yoe84jm32">
                    <span className="font-display text-2xl font-extrabold text-camelink" data-id="element-114" data-mp="31bzf2151asmp">
                      {step.number}
                    </span>
                    <Icon aria-hidden="true" className="h-5 w-5 text-muted" data-id="element-115" data-mp="2wjg1v5a9dzif" />
                  </div>
                  <h3 className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-116" data-mp="3aacidxqwuq94">
                    {t(step.title)}
                  </h3>
                </Reveal>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}